<div class="text-center model_form">
    <div class="CloseModel" (click)="closeModel()"><span><img src="assets/images/close.svg"  alt="close" /></span></div>
  <p>Identity Verification</p>
  <p>Continue the verification</p>
  <div class="stan_button stan1button" (click)='federated()'>
    <p>Continue with</p>
STANDARDC
<p>Credentials</p>

  </div>
  <div class="stan_button stan2button" (click)='openIDme()'>
    <p>Sign in with</p><img src="assets/images/idb.png">
  </div>
  <div  class="id_signup">
    <p >Dont have an Account? <span (click)='signUP()'  class="bold">Sign Up with ID.me </span></p>
  </div>
</div>